// extracted by mini-css-extract-plugin
module.exports = {"loader_wrapper":"loader_loader_wrapper__zbo_-","spin":"loader_spin__3ghAq"};